var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-pr-sm cursor-pointer text-grey-8 tex-body1 text-weight-light",on:{"click":_vm.handleSwitchCustomer}},[_vm._v(_vm._s(_vm.customerName))])}
var staticRenderFns = []

export { render, staticRenderFns }